/* eslint-disable one-var */
import store from '../../store/store'

export function showLoading () {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.classList.remove('in-active')
    appLoading.style.display = 'block'

    setTimeout(() => {
      appLoading.classList.add('active')
    }, 10)
  }
}

export function hideLoading () {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.classList.remove('active')
    appLoading.classList.add('in-active')

    setTimeout(() => {
      appLoading.style.display = 'none'
    }, 500)
  }
}

export function convertPersianNumberToEnglish (str) {
  const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
  const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]

  if (typeof str === 'string') {
    for (let i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i)
    }
  }
  return str
}

export function addComma (val) {
  let sign = ''
  let decimal = ''

  if (val - parseInt(val) > 0) {
    decimal = (val - parseInt(val)).toString().replace('0.', '.')
  }

  if (val < 0) sign = '-'

  val = parseInt(val).toString()

  if (val[0] === '0') val = val.substr(1, val.length - 1)

  return val.toString().replace(/\D/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + decimal + sign
}

export function addSpace (val, limit) {
  val = val.toString()

  if (val[0] === '0') val = val.substr(1, val.length - 1)

  if (limit && val.length > limit) val = val.substr(0, limit)

  val = val.toString().replace(/\D/g, '')

  const arr = []
  if (val.substr(0, 4) !== undefined) {
    arr.push(val.substr(0, 4))
  }

  if (val.substr(4, 4) !== undefined) {
    arr.push(val.substr(4, 4))
  }

  if (val.substr(8, 4) !== undefined) {
    arr.push(val.substr(8, 4))
  }

  if (val.substr(12, 4) !== undefined) {
    arr.push(val.substr(12, 4))
  }

  let copy = ''
  arr.forEach((elm) => {
    if (elm) {
      if (copy) copy += ' '

      copy += elm
    }
  })
  val = copy

  return val
}

/* check permissions */

export function checkUserPermissions (permission) {
  const permissions = store.state.auth.user.permissions

  if (Array.isArray(permission)) {
    let hasPermissions = 0
    // let permissions = JSON.parse(localStorage.getItem('permissions'))
    // eslint-disable-next-line camelcase
    permission.forEach((permission_item) => {
      if (permissions.indexOf(permission_item) > -1) {
        hasPermissions++
      }
    })
    return hasPermissions === permission.length ? 2 : hasPermissions > 0 ? 1 : 0
  } else {
    // let permissions = JSON.parse(localStorage.getItem('permissions'))
    return permissions.indexOf(permission) > -1
  }
}

/* /check permissions */

/* quick sort algorithm */

function swap (items, leftIndex, rightIndex) {
  const temp = items[leftIndex]
  items[leftIndex] = items[rightIndex]
  items[rightIndex] = temp
}

function partition (items, field, left, right) {
  const pivot = items[Math.floor((right + left) / 2)] // middle element
  let  i = left, // left pointer
    j = right // right pointer
  while (i <= j) {
    while (items[i][field] < pivot[field]) {
      i++
    }
    while (items[j][field] > pivot[field]) {
      j--
    }
    if (i <= j) {
      swap(items, i, j) // sawpping two elements
      i++
      j--
    }
  }
  return i
}

export function quickSort (items, field, left, right) {
  if (items.length > 1) {
    const index = partition(items, field, left, right) // index returned from partition
    if (left < index - 1) { // more elements on the left side of the pivot
      quickSort(items, field, left, index - 1)
    }
    if (index < right) { // more elements on the right side of the pivot
      quickSort(items, field, index, right)
    }
  }
  return items
}

/* /quick sort algorithm */
